import { Hub } from "aws-amplify";

let handledAuthErrorDispatch = false;

const handleAuthError = (error: any): boolean  => {
    const msg = error?.message || '';

    if (
        msg.includes('No current user') ||
        msg.includes('not authenticated') ||
        msg.includes('Expired') ||
        msg.includes('AccessDenied') ||
        msg.includes('NO_CURRENT_USER') ||
        msg.includes('NotAuthorized')
    ) {
        if (!handledAuthErrorDispatch) {
            handledAuthErrorDispatch = true;
            Hub.dispatch('auth', { event: 'tokenExpired' });
        }
        return true;
    }

    return false;
};

export { handleAuthError };
